import script from "./CoreInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./CoreInformation.vue?vue&type=script&setup=true&lang=js"

import "./CoreInformation.vue?vue&type=style&index=0&id=316d395e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-316d395e"]])

export default __exports__